module.exports = __webpack_public_path__ + "img/ad-placement-active.37115751.svg";